import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import {
  COACH_PROGRAMS_ROUTE,
  HOME_ROUTE,
  LOGIN_ROUTE,
  REQUIRE_LOGOUT_ROUTE,
  SIGN_UP_ROUTE,
} from "../routes";
import { ALREADY_LOGGED_IN_TOAST_MESSAGE, UserRole } from "../../constants";

interface RequireUnauthorizedProps {
  role?: UserRole;
}

export const RequireUnauthorized = ({ role }: RequireUnauthorizedProps) => {
  const location = useLocation();

  const authorized = !!role;
  const isCoach = role === UserRole.COACH;

  const isAuthorizedSignUpOrLoginRoute =
    location.pathname.includes(SIGN_UP_ROUTE) ||
    location.pathname.includes(LOGIN_ROUTE);

  const homeUserRoute = isCoach ? COACH_PROGRAMS_ROUTE : HOME_ROUTE;

  return authorized ? (
    isAuthorizedSignUpOrLoginRoute ? (
      <Navigate
        to={homeUserRoute}
        state={{
          from: location,
          toastMessage: ALREADY_LOGGED_IN_TOAST_MESSAGE,
        }}
        replace
      />
    ) : (
      <Navigate to={REQUIRE_LOGOUT_ROUTE} state={{ from: location }} replace />
    )
  ) : (
    <Outlet />
  );
};
